<!-- @format -->
<works-list-tag>
  <div class="contents_block skillsheet">
    <div class="contents-inner_block margin-spacing-3_bottom" each={ item in works.list }>
      <div class="box_flex01 margin-spacing-3_bottom">
        <h2 class="works_heading">{item.title}</h2>
        <div class="box_flex03">
          <div
            class="button button-secondary-mini"
            onclick="{e=>edit(e, item.id)}"
            type="button"
            value="実績を編集する"
            data-target=""
          >実績を編集する</div>
          <div
            class="button button-secondary-mini button-border margin-spacing-1_left"
            onclick="{e=>openConfirm(e, item.id, item.title)}"
            type="button"
            value="削除"
            data-target=""
          >削除</div>
        </div>
      </div>
      <div class="container_profile">
        <div class="box_pic" if="{item.thumbnail}">
          <div class="picture">
            <img src="/public-info/works/api/v1/image?file_hash={item.thumbnail}" />
          </div>
        </div>
        <div class="box_text">
          <h3 class="heading-04 margin-spacing-1_bottom">担当分野</h3>
          <ul class="scope_list margin-spacing-2_bottom">
            <li class="scope_list-item" each={ skill in item.in_charge_fields }>
              <span class="skill_label">{skill}</span>
            </li>
          </ul>

          <h3 class="heading-04 margin-spacing-1_bottom">コメント</h3>
          <p class="comment">{item.comment}</p>

          <ul class="reference_list margin-spacing-2_top">
            <li class="reference_list-item" if="{item.url}">
              <a class="reference_list-item_website" href="{item.url}">サイトを開く</a>
            </li>
            <li class="reference_list-item" if="{item.files}">
              <a class="reference_list-item_documents" href="/public-info/works/api/v1/image?file_hash={item.files}">参考資料を見る</a>
            </li>
          </ul>
        </div>
      </div>
      <!--/.container_profile-->
    </div>
    <!--/.contents-inner_block-->

    <div class="box_flex03">
      <div
          class="button button-secondary-large"
          type="button"
          onclick="{fetchItem}" onmouseup="{fetchItem}"
          value="制作実績を新規登録"
          data-target=""
      >制作実績を新規登録</div>

    </div>
  </div>
  <div is="confirm" title="{title}" isOpen="{confirmIsOpen}" onClose="{closeConfirm}" onSubmit="{remove}"></div>
  <script>
    import di from "dependency-injection";
    import works from "@model/works/api";
    import confirm from "@tags/modal/works-confirm.riot";

    export default {
      components: {
        confirm: confirm
      },
      id: null,
      titile:'',
      works: works,
      confirmIsOpen: false,
      edit(e, id) {
        e.preventDefault()
        this.works.trigger('fetch', id)
      },
      fetchItem(e) {
        e.preventDefault()
        this.works.trigger('fetch', null)
      },
      async remove() {
        let res = await this.works.request('works', 'delete', {work_id: this.id})
        di.toast.push(this.title + "を削除しました。", "negative")
        this.confirmIsOpen = false
        this.works.trigger('list')
      },
      closeConfirm() {
        this.confirmIsOpen = false
        this.update()
      },
      openConfirm(e, id, title) {
        e.preventDefault()
        this.id = id
        this.title = title
        this.confirmIsOpen = true
        this.update()
      }
    }
  </script>
</works-list-tag>